// Initialize Firebase
export const firebaseConfig = {
    apiKey: "AIzaSyBVvKsv7nvcKXDMoSZAwVHzQhkZcB4favw",
    authDomain: "auctioneer-89b54.firebaseapp.com",
    databaseURL: "https://auctioneer-89b54.firebaseio.com",
    projectId: "auctioneer-89b54",
    storageBucket: "auctioneer-89b54.appspot.com",
    messagingSenderId: "349172383165",
    appId: "1:349172383165:web:aea8e3ec583aeddc"
  };